<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{ $t('form.search.legend') }}</legend>
          <ncs-elements-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{ $t('form.result.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{ $t('form.sensitivity.legend') }}</legend>
          <ncs-sensitivity name="case"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{ $t('form.filters.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-select id="documents.level"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.gender"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.l1"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.english_status"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.preparation_course"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.text_formality"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.text_type"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.illocutionary_act"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.text_topic"/>
            </div>
            <div class="col-md-6">
              <ncs-multi-select id="documents.candidate_number" :searchable="true"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.several_texts"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end mt-3">
        <ncs-download-button/>
        <ncs-back-button/>
        <button type="button" class="btn btn-primary" @click="reload()">
          {{ $t('reset') }}
        </button>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-context-result/>
      <documents-result/>
    </ncs-result>
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from 'vue'
import { initialize } from 'ncs'
import DocumentsResult from './DocumentsResult.vue'

onMounted(async () => await initialize())
const reload = () => location.reload()
</script>
<style lang="scss">
@import "../../scss/variables";

legend {
  color: $primary;
  border-bottom: 1px solid $primary;
  font-size: 14px;
  margin-bottom: 5px;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
}

.form-group {
  margin-bottom: 0.25rem;
}
</style>
